<template>
  <div class="container-custom">
    <v-form ref="form" @submit.prevent="saveHandler">
      <Breadscrumbs
        :links="[
          {
            name: 'EDMSCenter',
            to: {
              name: 'EDMSCenter'
            }
          },
          {
            name: 'Edit',
            to: {
              name: 'EDMSEdit',
              params: {
                id: $route.params.id
              }
            }
          }
        ]"
      ></Breadscrumbs>
      <!-- page-actions -->
      <div class="page-actions">
        <h2>修改EDM</h2>
        <v-spacer></v-spacer>
        <button class="btn mr-5" @click="cancelHandler">
          <span>取消</span>
        </button>
        <button class="btn btn-primary" type='submit'>
          <span>儲存</span>
        </button>
      </div>
    </v-form>
    <!-- Block 修改EDM -->
    <EDMSCreateEdit></EDMSCreateEdit>
    <LangDialog :isOpen.sync="isLangOpen" @confirm-submit="saveHandler()"></LangDialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import EDMSCreateEdit from '@/views/E-9__Edms/c/EDMSCreateEdit.vue';
import LangDialog from '@/components/LangSubmitDialog.vue';

export default {
  components: {
    Breadscrumbs,
    EDMSCreateEdit,
    LangDialog,
  },
  data: () => ({
    isLangOpen: false,
  }),
  computed: {
    ...mapState(['lang']),
    ...mapState('edms', ['edms']),
  },
  async created() {
    if (this.$route.params.id) {
      await this.getEDMS(this.$route.params.id);
    }
  },
  methods: {
    ...mapActions('edms', {
      getEDMS: 'findById',
      save: 'save',
    }),
    cancelHandler() {
      this.$router.push({ name: 'EDMSCenter' });
    },
    saveHandler() {
      if (this.isLangOpen || !this.lang.id) {
        this.errors = [];
        if (this.$refs.form.validate()) {
          if (!this.edms.title) {
            this.errors.push('標題 required.');
          } else if (!this.edms.tab) {
            this.errors.push('Tab required.');
          } else if (!this.edms.published_at) {
            this.errors.push('發佈日 required.');
          } else if (!this.edms.cover_image) {
            this.errors.push('封面圖 required.');
          } else if (!this.edms.content) {
            this.errors.push('內容 required.');
          }
          if (this.errors.length > 0) {
            /* eslint-disable */
            alert(this.errors);
            /* eslint-disable */
            return false;
          }
          this.save(this.edms).then(() => {
            this.$router.push({ name: 'EDMSCenter' });
          });
        }
      } else {
        this.isLangOpen = true;
      }
    },
  },
};
</script>

<style></style>
